import { maritalStatus } from "../groupForm/formUtils";

export const displayMaritalStatus = (status) => {
  const stat = maritalStatus.find((e) => e.value === status);
  return stat.label;
};
